import { applyQueryParams } from "../utils/request";
import instance from "./api";
import { execute } from "./response";

const endpoints = {
  players: `${process.env.REACT_APP_API_URL}/api/players`,
};

const fetchAllPlayers = async (params) => {
  const queryParams = params
    ? params.map((x) => `${x.key}=${x.value}`).join("&")
    : "";
  const res = await instance.get(
    `${endpoints.players}${queryParams ? `?${queryParams}` : ""}`
  );
  return res.data;
};

const mergePlayers = async (sport, data) => {
  const endpoint = `${process.env.REACT_APP_API_URL}/api/players/${sport}/merge`;
  return execute(() => instance.post(applyQueryParams(endpoint), data));
};

const matchPlayersByAi = async (sport, payload) => {
  const endpoint = `${process.env.REACT_APP_API_URL}/api/players/${sport}/ai/match`;
  const result = await execute(() => instance.post(applyQueryParams(endpoint), payload));
  return result;
};

const approvePlayer = async (id) => {
  const endpoint = `${process.env.REACT_APP_API_URL}/api/players/${id}/approve`;
  return execute(() => instance.post(endpoint));
};

const unapprovePlayer = async (id) => {
  const endpoint = `${process.env.REACT_APP_API_URL}/api/players/${id}/unapprove`;
  return execute(() => instance.post(endpoint));
};

export { fetchAllPlayers, mergePlayers, matchPlayersByAi, approvePlayer, unapprovePlayer };
